import {Component, EventEmitter, Input, Output} from '@angular/core';
import {RcFormControlAbstract} from '../rc-form-control-abstract/rc-form-control-abstract';
import {RcTimeService} from '../../../rc-utils/rc-time/rc-time.service';

/**
 * Rc datepicker - currently wrap ngx bootstrap datepicker
 *
 * @example
 * <lib-rc-datepicker placeholder="myPlaceHolder" control="dateControl" valueChangedCallback="valuChanged($event)"></lib-rc-datepicker>
 */
@Component({
    selector: 'lib-rc-datepicker',
    template: `<div class="rc-datepicker-wrapper" [ngClass]="{'has-open-button': hasOpenButton}">
    <input type="text"
           [placeholder]="placeholder"
           class="form-control"
           [minDate]="_minDate"
           [maxDate]="_maxDate"
           [value]="getFormattedValue"
           #dp="bsDatepicker"
           [bsValue]="initialStateValue"
           [attr.disabled]="_disabled"
           attr.aria-label="{{ariaLabel}}"
           attr.aria-describedby="{{getAriaDescribedBy()}}"
           [bsConfig]="datePickerConfig"
           (bsValueChange)="onValueChange($event)"
           bsDatepicker
    >
    <ng-container *ngIf="hasOpenButton">
        <button id="rc-datepicker-toggle-button-{{elementId}}" class="rc-date-picker-toggle-button" [ngClass]="{'is-open': dp.isOpen}" (click)="dp.toggle()" [attr.aria-expanded]="dp.isOpen">
            <ng-content select="[openButtonContent]"></ng-content>
        </button>
    </ng-container>
</div>
<div role="alert" id="{{errorElementId}}" class="invalid-feedback-message" *ngIf="errorMsg">{{ errorMsg }}</div>
`,
    styles: [`.rc-datepicker-wrapper.has-open-button{display:flex;flex-direction:row}.rc-datepicker-wrapper.has-open-button .rc-date-picker-toggle-button{border:none;background-color:transparent;cursor:pointer}`]
})
export class RcDatepickerComponent extends RcFormControlAbstract {

    /**
     * Extra datepicker config
     */
    @Input() config: any = {};

    /**
     * Minimum date
     */
    @Input()
    set minDate(value: Date | string) {
        this._minDate = new Date(value);
    }
    public _minDate: Date;

    private prevValue;

    /**
     * Maximum date
     */
    @Input()
    set maxDate(value: Date | string) {
        this._maxDate = new Date(value);
    }
    public _maxDate: Date;

    /**
     * Placeholder
     */
    @Input() placeholder: string = 'Selected Date';

    /**
     * has open button
     */
    @Input() hasOpenButton: boolean;

    @Output() onDateChange: EventEmitter<any> = new EventEmitter();

    public initialStateValue;
    /**
     * Default config
     */
    public datePickerConfig = {
        dateInputFormat: 'DD/MM/YYYY', showWeekNumbers: false
    };

    constructor(private timeService: RcTimeService) {
        super();
    }

    ngOnInit() {
        super.ngOnInit();
        this.datePickerConfig = Object.assign({}, this.datePickerConfig, this.config);
        if (this.control && this.control.value) {
            this.initialStateValue = new Date(this.control.value);
            this.prevValue = this.control.value;
        }
    }

    get getFormattedValue() {
        if (this.control.value) {
            return this.timeService.format(this.control.value, this.timeService.defaultServerDateFormat, this.datePickerConfig.dateInputFormat)
        }
        return null;
    }

    /**
     * emit an Output function on change
     * @param $event $event
     */
    onValueChange($event: Date): void {
        const outputDate = this.timeService.formatFromJsDate($event);

        this.control.setValue(outputDate);

        this.onChange(outputDate);

        if (this.prevValue !== outputDate) {
            if (this.onDateChange.observers.length) {
                this.onDateChange.emit(this.control.value);
            }
        }
        this.prevValue = outputDate;
    }
}
